export default __webpack_public_path__ + "static/board-8d698d4abe9d6424416898b6665bd2ab.webp";